import createLucideIcon from '../createLucideIcon';

const ChevronsRight = createLucideIcon('ChevronsRightIcon', [
  ['path', { d: 'm6 17 5-5-5-5', key: 'xnjwq' }],
  ['path', { d: 'm13 17 5-5-5-5', key: '17xmmf' }],
]);

export default ChevronsRight;
